// LO QUE SE LE PREGUNTA AL EQUIPO ANTES DE PUBLICAR UN INFORME (REP-13, auditoría del 14-10).
//
// "Publicar el informe" publicaba al primer clic aunque no hubiera feedback escrito, y
// publicar no se puede deshacer desde la pantalla. Publicar sin feedback puede ser lo que se
// quiere, así que no se impide: se pregunta, diciendo lo que va a pasar.
//
// Cuenta lo GUARDADO, que es lo que lleva el informe: un feedback escrito en la caja y sin
// guardar no sale, y eso se dice aparte porque es el despiste más fácil. Lo que después lee
// el cliente lo decide el servidor con el reporte delante (`core/promesa_del_reporte.py`,
// `lo_que_lleva`); aquí solo se decide si hay que preguntar.
//
// Puro: ni red ni pantalla. Devuelve las opciones del diálogo de `useConfirm`, o `null` si
// se puede publicar sin preguntar.
export function preguntaAntesDePublicar({ guardado, borrador } = {}) {
    if ((guardado || '').trim()) return null;
    const sinGuardar = !!(borrador || '').trim();
    return {
        title: 'Vas a publicarlo sin feedback',
        description: sinGuardar
            ? 'Has escrito un feedback pero no lo has guardado: el informe saldría sin él. Guárdalo antes de publicar, porque publicar no se puede deshacer.'
            : 'El cliente recibirá su informe sin ningún comentario del equipo. Publicar no se puede deshacer.',
        confirmLabel: 'Publicarlo sin feedback',
        cancelLabel: sinGuardar ? 'Volver y guardarlo' : 'Volver y escribirlo',
    };
}
